module.exports = {
          srcSet: __webpack_public_path__ + "4f9b4ce71473a2927b856e48b659917b-470.png"+" 470w",
          images:[ {path: __webpack_public_path__ + "4f9b4ce71473a2927b856e48b659917b-470.png",width: 470,height: 334}],
          src: __webpack_public_path__ + "4f9b4ce71473a2927b856e48b659917b-470.png",
          toString:function(){return __webpack_public_path__ + "4f9b4ce71473a2927b856e48b659917b-470.png"},
          
          width: 470,
          height: 334
        }